import React, { useContext } from "react"
import GameContext from "../../../Context/GameContext"
import { turnStatesSolo } from "../../shared/constants"
import { TurnIntro } from "../turn-solo/TurnIntro"
import { TurnQuestion } from "../turn-solo/TurnQuestion"

export const RoundPlayerTurns = props => {
  const { gameState } = useContext(GameContext)
  const turnStateSolo = gameState?.turnStateSolo

  if (!turnStateSolo) return <div>No turnStateSolo defined</div>

  switch (turnStateSolo) {
    case turnStatesSolo.INTRO:
      return <TurnIntro {...props} />
    case turnStatesSolo.QUESTION:
      return <TurnQuestion {...props} />
    case turnStatesSolo.PREVIEW:
      return <TurnQuestion {...props} />
    default:
      return <div>turnStateSolo invalid</div>
  }
}
